import type { NPCConfig } from '@/entities';
import v2Day1SharedNPCs from "@/config/NPCConfigs/v2/V2Day1SharedNPCs.ts";
// import {StoryManager} from "@/systems";

const config: NPCConfig[] = [
    //Bunga : lagi didepan rumah kalau didkeetin trigger auto next 'stage;, dia bilang ulang tahn
    //
  ...v2Day1SharedNPCs,
  {
    x: 3950,
    y: 860,
    name: 'Kuburan Ibu',
    spriteImage: 'assets/sprite/nada.png', // Use NPC image
    dialogTree: {
      startDialogId: 'kuburan1',
      nodes: {
        kuburan1: {
          id: 'penjual_part1_1',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Ini adalah tempat ibu dikubur...`,
          nextDialogId : "kuburan2",
        },
        kuburan2: {
          id: 'kuburan2',
          speaker: 'Yan',
          text: `Kadang merasa sedih jika mengingat masa kecil, saat aku dan Diana ditinggal oleh Ibu`,
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId : "kuburan3",
        },
        kuburan3: {
          id: 'kuburan3',
          speaker: 'Yan',
          text: `Orang desa pun masih tidak tahu bagaimana ibu bisa meninggal, sedangkan aku dan Diana masih sangat kecil.`,
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId : "kuburan4",
        },
        kuburan4: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Sejak saat itu kita dibesarkan oleh nenek, kami sangat berterima kasih ke nenek. Semoga nenek sehat selalu`,
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId : "kuburan5",
        },
        kuburan5: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Oh apa ini di kuburan, sepertinya ada uang`,
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId : "kuburan6",
        },
        kuburan6: {
          id: 'kuburan5',
          speaker: 'Yan',
          text: ``,
          characterImage: '/assets/character/v2/yanf.png',
          choices: [
            {
              text: 'Ambil uang itu.',
              itemReward: { itemId: 'coin_gold', quantity: 200},
              nextDialogId : "kuburan6a",
            },
            {
              text: 'Jangan Ambil',
              nextDialogId : "kuburan6b",
            },
          ],
        },
        kuburan6a: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Yan mendapat 200 rupiah!`,
          storyAction : { type: 'addCustomValue', value: {key : "general_karma", value : -1} },
          characterImage: '/assets/character/v2/yanf.png',
          isEnd : true,
        },
        kuburan6b: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Sebaiknya kita tinggalkan uang ini.`,
          characterImage: '/assets/character/v2/yanf.png',
          isEnd : true,
        },
      },
    },
  },
  {
    x: 3220,
    y: 1450,
    name: 'Bunga',
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga1',
      triggerOnCollision: true,
      nodes: {
        bunga1: {
          id: 'bunga1',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          text: `Halo Yan, apakah sudah bertemu dengan Diana?`,
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga2",
        },
        bunga2: {
          id: 'bunga2',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          text: ``,
          choices: [
            {
              text: 'Diana sedang mencari Elsa di danau.',
              nextDialogId : "bunga3",
            },
            {
              text: 'Diana sedang ke danau.',
              nextDialogId : "bunga4",
            },
          ],
        },
        bunga3: {
          id: 'bunga3',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          text: `Elsa... Merepotkan semua orang saja.`,
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga4",
        },
        bunga4: {
          id: 'bunga4',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          text: `Baiklah, kalau begitu aku juga akan ke Danau.`,
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga5",
        },
        bunga5: {
          id: 'bunga4',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          text: `Sebaiknya kamu menyusul setelah menemukan kado untuk Diana.`,
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga6"
        },
        bunga6: {
          id: 'bunga6',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          text: ``,
          choices: [
            {
              text: 'Tenang saja. Kado sudah siap, tinggal dibungkus dan aku menyusul!',
              storyAction: { type: 'nextDay', value: 0 },
              isEnd : true
            },
            {
              text: 'Berikan aku waktu, masih aku cari. Nanti aku segera datang',
              storyAction: { type: 'nextDay', value: 0 },
              isEnd : true
            },
          ],
        },
      },
    },
  },
  // {
  //   x: 3900,
  //   y: 2100,
  //   name: '',
  //   color: 0x9932cc, // Dark orchid
  //   spriteImage: 'assets/sprite/sprite_sondakh_dead.png', // Use NPC image
  //   repeatable: true, // Day Keeper should have repeatable dialogs
  //   dialogTree: {
  //     startDialogId: 'bunga_part2_1',
  //     nodes: {
  //       bunga_part2_1: {
  //         id: 'bunga_part2_1',
  //         speaker: '',
  //         text: ``,
  //         characterImage: '/assets/character/v2/bunga.png',
  //         backgroundImage: '/assets/cutscene/death_sondakh.png',
  //         nextDialogId : "bunga_day1_2",
  //         isEnd : true
  //       },
  //     },
  //   },
  // },
];

export default config;
